module.exports = __webpack_public_path__ + "img/Group 16.915fd066.svg";